import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
  type ActionResponse,
} from '@acme/api';

export function isShow(
  actions: ActionResponse[] | null | undefined,
  kind: DefinitionActionKindEnum,
  subKind?: DefinitionActionSubKindEnum
): boolean {
  if (!actions?.length) return false;

  if (subKind == null) {
    return actions.some((a) => a.kind === kind);
  }

  return actions.some((a) => a.kind === kind && a.subKind === subKind);
}
